import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { withI18nSupport } from '@instructure/quiz-common';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { formatTime } from '../../../util/formatTimespan';
import { Text } from '@instructure/ui-text';
export var DAY_IN_SECONDS = 86400;
export var HOUR_IN_SECONDS = 3600;
export var MINUTE_IN_SECONDS = 60;

/**
 * @param  {integer} seconds Number of seconds
 * @return {object}
 */
export function breakdownSeconds(seconds) {
  var includeDays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (seconds <= 0 || seconds === null || seconds === void 0) {
    return _objectSpread(_objectSpread({}, includeDays && {
      days: 0
    }), {}, {
      hours: 0,
      minutes: 0,
      seconds: 0
    });
  }
  return _objectSpread({
    seconds: seconds % MINUTE_IN_SECONDS,
    minutes: Math.floor(seconds / MINUTE_IN_SECONDS) % MINUTE_IN_SECONDS,
    hours: includeDays ? Math.floor(seconds % DAY_IN_SECONDS / HOUR_IN_SECONDS) : Math.floor(seconds / HOUR_IN_SECONDS)
  }, includeDays && {
    days: Math.floor(seconds / DAY_IN_SECONDS)
  });
}
export var FormattedTimer = /*#__PURE__*/function (_withI18nSupport) {
  function FormattedTimer() {
    _classCallCheck(this, FormattedTimer);
    return _callSuper(this, FormattedTimer, arguments);
  }
  _inherits(FormattedTimer, _withI18nSupport);
  return _createClass(FormattedTimer, [{
    key: "render",
    value: function render() {
      var _breakdownSeconds = breakdownSeconds(this.props.seconds),
        hours = _breakdownSeconds.hours,
        minutes = _breakdownSeconds.minutes,
        seconds = _breakdownSeconds.seconds;
      var altText = formatTime(this.props.seconds);
      var display = hours > 0 ? t('{ hours }:{ minutes }:{ seconds }', {
        hours: this.formatDecimal2MinIntegerNoFraction(hours),
        minutes: this.formatDecimal2MinIntegerNoFraction(minutes),
        seconds: this.formatDecimal2MinIntegerNoFraction(seconds)
      }) : t('{ minutes }:{ seconds }', {
        minutes: this.formatDecimal2MinIntegerNoFraction(minutes),
        seconds: this.formatDecimal2MinIntegerNoFraction(seconds)
      });
      return /*#__PURE__*/React.createElement(AccessibleContent, {
        alt: altText
      }, /*#__PURE__*/React.createElement(Text, {
        color: "primary",
        size: this.props.fontSize,
        weight: this.props.fontWeight
      }, display));
    }
  }]);
}(withI18nSupport(Component));
_defineProperty(FormattedTimer, "propTypes", {
  fontSize: Text.propTypes.size,
  fontWeight: Text.propTypes.weight,
  seconds: PropTypes.number
});
_defineProperty(FormattedTimer, "defaultProps", {
  fontSize: Text.defaultProps.size,
  fontWeight: Text.defaultProps.weight,
  seconds: 0
});
_defineProperty(FormattedTimer, "contextTypes", {
  locale: PropTypes.string
});
export default FormattedTimer;